export * from './fromuInfoList.component';
export * from './fromuList.component';
export * from './fromu/index';

